import React from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import {TextField} from "@mui/material";

export const ColorField: FieldComponent<string> = ({
  value,
  onChange,
  isActive,
  intent,
}) => {
  const hexColor = `#${value}`;
  if (!isActive) {
    return (
      <div
        style={{ width: '100%', height: '100%', background: hexColor }}
        className={'bp4-tag'}
      />
    );
  }
  return (
    <></>
  );
};

ColorField.includes = () => false;

ColorField.comparator = () => 0;

ColorField.FilterRenderer = () => <TextField />;
